import { Box, SxProps, Theme } from '@mui/material';
import { ReactNode } from 'react';

const pillSx: SxProps<Theme> = {
  px: 1,
  py: 0.25,
  minHeight: 24,
  borderRadius: 4,
  bgcolor: 'rgba(0,0,0,0.7)',
  color: 'white',
  typography: 'caption',
  display: 'inline-flex',
  alignItems: 'center',
};

/**
 * Reusable pill for fragment card media overlays (poster). Shared look for status,
 * time/duration, and meta so all overlay pills align (same minHeight and style).
 */
export function FragmentMediaPill({
  children,
  gap = 0.25,
  sx,
}: {
  children: ReactNode;
  gap?: number;
  sx?: SxProps<Theme>;
}) {
  if (!children) {
    return null;
  }

  return (
    <Box
      component="span"
      sx={
        {
          ...pillSx,
          gap: gap as number,
          ...(sx && typeof sx === 'object' && !Array.isArray(sx) ? sx : {}),
        } as SxProps<Theme>
      }
    >
      {children}
    </Box>
  );
}
